import { sendPost } from '../http.js'
const api = {
	'activeList': '/user/user/active/list',
    'activeAdd': '/user/user/active/add',
    'productSelect': '/user/user/product/select',
    'activeDel': '/user/user/active/del',
    'activeSurplus': '/user/user/active/surplus'

}
export default {
	activeList(params) {
	    return sendPost(api.activeList, params)
	},
    activeAdd(params) {
        return sendPost(api.activeAdd, params)
    },
    productSelect(params) {
        return sendPost(api.productSelect, params)
    },
    activeDel(params) {
        return sendPost(api.activeDel, params)
    },
    activeSurplus(params) {
        return sendPost(api.activeSurplus, params)
    }
}